import request from '@/utils/request'

export function startLottery(data) { // 抽奖
  return request({
    url: 'mall.api.member/getLottery',
    method: 'post',
    data,
  })
}

export function delLottery(data) { // 重置抽奖
  return request({
    url: 'mall.api.del/coupon',
    method: 'post',
    data,
  })
}

export function obtainCoupon(data) { // 获取优惠券
  return request({
    url: 'mall.api.member/getCoupon',
    method: 'post',
    data,
  })
}

export function getUsedCoupon(data) { // 获取已使用优惠券
  return request({
    url: 'mall.api.member/getCouponHistoryUsed',
    method: 'post',
    data,
  })
}

export function getFailCoupon(data) { // 获取已失效优惠券
  return request({
    url: 'mall.api.member/getCouponHistoryExpired',
    method: 'post',
    data,
  })
}

export function getNavMenu(data) { // 获取菜单栏
  return request({
    url: 'mall.api.login/menuBar',
    method: 'post',
    data,
  })
}